import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import americanExpress from "assets/graphics/icons/cards/american-express.jpg";
import dinersClub from "assets/graphics/icons/cards/diners-club.jpg";
import discover from "assets/graphics/icons/cards/discover.jpg";
import jcb from "assets/graphics/icons/cards/jcb.jpg";
import mastercard from "assets/graphics/icons/cards/mastercard.jpg";
import unionPay from "assets/graphics/icons/cards/union-pay.jpg";
import visa from "assets/graphics/icons/cards/visa.jpg";

import "features/application/payment/view.scss";

const PaymentView = ({
  billingAddress,
  validityReference,
  deleteCreditCard,
  backToPreviousStep,
  sendApiRequest,
  errorCodes,
  goToNextStep,
}) => (
  <form
    className="form__content payment__content"
    noValidate
    onSubmit={sendApiRequest}
  >
    <h1 className="payment__headline application__headline form__elongation">
      Card
    </h1>
    <p className="payment__description form__elongation">
      Upon approval of your Premium membership your credit card will be charged.
    </p>
    {billingAddress && Object.keys(billingAddress).length ? (
      <div className="payment__credit-card form__elongation">
        <span className="payment__brand">
          <img
            src={
              billingAddress.card_brand === "American Express"
                ? americanExpress
                : billingAddress.card_brand === "Diners Club"
                ? dinersClub
                : billingAddress.card_brand === "Discover"
                ? discover
                : billingAddress.card_brand === "JCB"
                ? jcb
                : billingAddress.card_brand === "MasterCard"
                ? mastercard
                : billingAddress.card_brand === "Union Pay"
                ? unionPay
                : billingAddress.card_brand === "Visa" && visa
            }
            alt="card brand"
          />
          <span className="payment__number">
            {billingAddress.card_last_four}
          </span>
        </span>
        <span>
          Month/Year:
          <span className="payment__validity">
            {" "}
            {`${billingAddress.exp_month}/${billingAddress.exp_year}`}
          </span>
        </span>
        <button
          className="payment__delete"
          type="button"
          onClick={() => deleteCreditCard(billingAddress.id)}
        >
          Delete
        </button>
      </div>
    ) : (
      <Fragment>
        <Field
          label="Credit card"
          placeholder="Card number"
          name="number"
          type="text"
          maxLength={19}
          shouldValidate={true}
          rule="cardNumber"
          error="It doesn't look like a valid field."
        />
        <div className="payment__group">
          <Field
            placeholder="Month/Year"
            name="validity"
            type="text"
            maxLength={5}
            shouldValidate={true}
            rule="validity"
            error="It doesn't look like a valid field."
            reference={validityReference}
          />
          <Field
            placeholder="CVV"
            name="cvc"
            type="text"
            maxLength={4}
            shouldValidate={true}
            rule="cvv"
            error="It doesn't look like a valid field."
          />
        </div>
      </Fragment>
    )}
    <div className="form__elongation payment__space"></div>
    <div className="form__elongation">
      <Field
        label="Billing Address"
        placeholder="Name"
        name="name"
        type="text"
        maxLength={191}
        value={billingAddress && billingAddress.name && billingAddress.name}
        shouldValidate={true}
        rule="required"
        error="It doesn't look like a valid field."
        disabled={billingAddress && Object.keys(billingAddress).length}
      />
      <Field
        placeholder="Street"
        name="address_line1"
        type="text"
        maxLength={191}
        value={
          billingAddress &&
          billingAddress.address_line1 &&
          billingAddress.address_line1
        }
        shouldValidate={true}
        rule="required"
        error="It doesn't look like a valid field."
        disabled={billingAddress && Object.keys(billingAddress).length}
      />
    </div>
    <Field
      placeholder="City"
      name="address_city"
      type="text"
      maxLength={191}
      value={
        billingAddress &&
        billingAddress.address_city &&
        billingAddress.address_city
      }
      shouldValidate={true}
      rule="required"
      error="It doesn't look like a valid field."
      disabled={billingAddress && Object.keys(billingAddress).length}
    />
    <div className="payment__group">
      <Field
        placeholder="State code"
        name="address_state"
        type="text"
        maxLength={191}
        value={
          billingAddress &&
          billingAddress.address_state &&
          billingAddress.address_state
        }
        shouldValidate={true}
        rule="required"
        error="It doesn't look like a valid field."
        disabled={billingAddress && Object.keys(billingAddress).length}
      />
      <Field
        placeholder="Zip code"
        name="address_zip"
        type="text"
        maxLength={10}
        value={
          billingAddress &&
          billingAddress.address_zip &&
          billingAddress.address_zip
        }
        shouldValidate={true}
        rule="zipCode"
        error="It doesn't look like a valid field."
        disabled={billingAddress && Object.keys(billingAddress).length}
      />
    </div>
    {((errorCodes.creditCard &&
      errorCodes.creditCard.toString().startsWith("4")) ||
      (errorCodes.billingAddress &&
        errorCodes.billingAddress.toString().startsWith("4"))) && (
      <p className="form__elongation form__information">
        The given data was invalid. Please, check your credit card information.
      </p>
    )}
    {billingAddress && Object.keys(billingAddress).length ? (
      <p className="form__elongation form__information">
        To edit credit card information, first delete the card.
      </p>
    ) : null}
    <div className="payment__buttons application__buttons form__elongation">
      <button
        className="application__button"
        type="button"
        onClick={backToPreviousStep}
      >
        Back
      </button>
      <button
        className="application__button"
        type={
          billingAddress && Object.keys(billingAddress).length
            ? "button"
            : "submit"
        }
        onClick={
          billingAddress && Object.keys(billingAddress).length
            ? goToNextStep
            : null
        }
      >
        Next
      </button>
    </div>
  </form>
);

PaymentView.propTypes = {
  billingAddress: PropTypes.object,
  validityReference: PropTypes.object,
  deleteCreditCard: PropTypes.func,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
  errorCodes: PropTypes.object,
  goToNextStep: PropTypes.func,
};

export default PaymentView;
